// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as RetosRouteImport } from './routes/retos'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as MapRouteImport } from './routes/map'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CreateRouteImport } from './routes/create'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RideRideIdRouteImport } from './routes/ride.$rideId'
import { Route as PuertoIdRouteImport } from './routes/puerto.$id'
import { Route as ProfileRidesRouteImport } from './routes/profile_.rides'
import { Route as ProfileUserIdRouteImport } from './routes/profile_.$userId'
import { Route as RetosIndexRouteImport } from './routes/retos.index'
import { Route as RetosProvinciasRouteImport } from './routes/retos.provincias'
import { Route as RetosIdRouteImport } from './routes/retos.$id'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminVerifyMfaRouteImport } from './routes/admin.verify-mfa'
import { Route as AdminVerificationsRouteImport } from './routes/admin.verifications'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminStatsRouteImport } from './routes/admin.stats'
import { Route as AdminSetupMfaRouteImport } from './routes/admin.setup-mfa'
import { Route as AdminRidesRouteImport } from './routes/admin.rides'
import { Route as AdminPuertosRouteImport } from './routes/admin.puertos'
import { Route as AdminNicknamesRouteImport } from './routes/admin.nicknames'
import { Route as AdminLocalesRouteImport } from './routes/admin.locales'
import { Route as AdminEmbajadoresRouteImport } from './routes/admin.embajadores'
import { Route as AdminClubsRouteImport } from './routes/admin.clubs'

const WelcomeRoute = WelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => rootRouteImport
          })
const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const RetosRoute = RetosRouteImport.update({
            id: '/retos',path: '/retos',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const MapRoute = MapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const CreateRoute = CreateRouteImport.update({
            id: '/create',path: '/create',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const ActivityRoute = ActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const RideRideIdRoute = RideRideIdRouteImport.update({
            id: '/ride/$rideId',path: '/ride/$rideId',getParentRoute: () => rootRouteImport
          })
const PuertoIdRoute = PuertoIdRouteImport.update({
            id: '/puerto/$id',path: '/puerto/$id',getParentRoute: () => rootRouteImport
          })
const ProfileRidesRoute = ProfileRidesRouteImport.update({
            id: '/profile_/rides',path: '/profile/rides',getParentRoute: () => rootRouteImport
          })
const ProfileUserIdRoute = ProfileUserIdRouteImport.update({
            id: '/profile_/$userId',path: '/profile/$userId',getParentRoute: () => rootRouteImport
          })
const RetosIndexRoute = RetosIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => RetosRoute
          })
const RetosProvinciasRoute = RetosProvinciasRouteImport.update({
            id: '/provincias',path: '/provincias',getParentRoute: () => RetosRoute
          })
const RetosIdRoute = RetosIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => RetosRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminVerifyMfaRoute = AdminVerifyMfaRouteImport.update({
            id: '/verify-mfa',path: '/verify-mfa',getParentRoute: () => AdminRoute
          })
const AdminVerificationsRoute = AdminVerificationsRouteImport.update({
            id: '/verifications',path: '/verifications',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const AdminStatsRoute = AdminStatsRouteImport.update({
            id: '/stats',path: '/stats',getParentRoute: () => AdminRoute
          })
const AdminSetupMfaRoute = AdminSetupMfaRouteImport.update({
            id: '/setup-mfa',path: '/setup-mfa',getParentRoute: () => AdminRoute
          })
const AdminRidesRoute = AdminRidesRouteImport.update({
            id: '/rides',path: '/rides',getParentRoute: () => AdminRoute
          })
const AdminPuertosRoute = AdminPuertosRouteImport.update({
            id: '/puertos',path: '/puertos',getParentRoute: () => AdminRoute
          })
const AdminNicknamesRoute = AdminNicknamesRouteImport.update({
            id: '/nicknames',path: '/nicknames',getParentRoute: () => AdminRoute
          })
const AdminLocalesRoute = AdminLocalesRouteImport.update({
            id: '/locales',path: '/locales',getParentRoute: () => AdminRoute
          })
const AdminEmbajadoresRoute = AdminEmbajadoresRouteImport.update({
            id: '/embajadores',path: '/embajadores',getParentRoute: () => AdminRoute
          })
const AdminClubsRoute = AdminClubsRouteImport.update({
            id: '/clubs',path: '/clubs',getParentRoute: () => AdminRoute
          })





const AdminRouteChildren = {
  AdminClubsRoute: AdminClubsRoute,AdminEmbajadoresRoute: AdminEmbajadoresRoute,AdminLocalesRoute: AdminLocalesRoute,AdminNicknamesRoute: AdminNicknamesRoute,AdminPuertosRoute: AdminPuertosRoute,AdminRidesRoute: AdminRidesRoute,AdminSetupMfaRoute: AdminSetupMfaRoute,AdminStatsRoute: AdminStatsRoute,AdminUsersRoute: AdminUsersRoute,AdminVerificationsRoute: AdminVerificationsRoute,AdminVerifyMfaRoute: AdminVerifyMfaRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const RetosRouteChildren = {
  RetosIdRoute: RetosIdRoute,RetosProvinciasRoute: RetosProvinciasRoute,RetosIndexRoute: RetosIndexRoute
}

const RetosRouteWithChildren = RetosRoute._addFileChildren(RetosRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,ActivityRoute: ActivityRoute,AdminRoute: AdminRouteWithChildren,AuthRoute: AuthRoute,CreateRoute: CreateRoute,ForgotPasswordRoute: ForgotPasswordRoute,MapRoute: MapRoute,OnboardingRoute: OnboardingRoute,PrivacyRoute: PrivacyRoute,ProfileRoute: ProfileRoute,ResetPasswordRoute: ResetPasswordRoute,RetosRoute: RetosRouteWithChildren,TermsRoute: TermsRoute,VerifyEmailRoute: VerifyEmailRoute,WelcomeRoute: WelcomeRoute,ProfileUserIdRoute: ProfileUserIdRoute,ProfileRidesRoute: ProfileRidesRoute,PuertoIdRoute: PuertoIdRoute,RideRideIdRoute: RideRideIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)